import { FormattedMessage } from 'react-intl';

import {
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorSettlementFrerquencyData } from '@/store/targetAccumulator/selectors.ts';

const SettlementFrequency = ({ useShortLabel = false }: { useShortLabel?: boolean }) => {
  const tileId = useTargetAccumulatorTileId();
  const { numberOfSettlements, settlementFrequency } = useAppSelector((state) =>
    selectTargetAccumulatorSettlementFrerquencyData(state, tileId),
  );
  const isCustom = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.customFields?.includes('SettlementFrequency') ?? false,
  );

  return (
    <TargetAccumulatorFormField
      formattedMessageId={`targetAccumulator.form.settlementFrequencies${useShortLabel ? '.short' : ''}`}
    >
      <div
        data-e2e="settlement-frequency-text"
        className={`${isCustom ? 'text-info' : ''} form-control-plaintext fs-12 ps-1 py-0`}
        data-e2e-is-modified={isCustom}
      >
        <FormattedMessage id={`targetAccumulator.form.fixingFrequencies.${settlementFrequency}`} /> (
        {numberOfSettlements})
      </div>
    </TargetAccumulatorFormField>
  );
};

export default SettlementFrequency;
